import { useEffect, useRef, useState } from 'react';
import { useHistory, withRouter, useParams } from "react-router-dom";
import { observer, inject } from "mobx-react";

import Header, { NavList } from "@/components/Base/header";
import SvgsCommons from "@/components/svgs/commons";
import Connect from './connect'
import { Root } from './css'

import Banner from '@/static/images/snap/banner.png'

const Index = ({ store }) => {
  const { isMobile } = store.common;

  const [show, setShow] = useState(false)
  const [installed, setInstalled] = useState(false)

  const onGet = () => {
    if (installed) {
      window.open('https://mail.dmail.ai/inbox')
    } else {
      setShow(true)
    }
  }

  return (
    <Root className={`${isMobile ? 'mobile' : ''}`}>
      <Header currentName='snap' />
      <div className="content">
        <div className="center snap">
          <div className="info">
            <h1>Never Miss an Email</h1>
            <h2>Instantly Check New Messages in Your Metamask Extension</h2>
            <div className="desc">
              <p>Dmail is now available on Metamask Snap!</p>
              <p>You can receive real-time email notifications and quickly view your messages directly within the Metamask extension—ensuring you never miss any important information!</p>
            </div>
            <div className="btn">
              <a className="filled-red" onClick={onGet}><SvgsCommons type="metamask" />{installed ? 'Launch Dmail' : 'Get the Snap'}</a>
            </div>
          </div>
          <div className="pic">
            <img src={Banner} width={isMobile ? 'auto' : 595} alt="" />
          </div>
        </div>
      </div>
      {!installed && <Connect show={show} setShow={setShow} setInstalled={setInstalled} />}
    </Root>
  )
}

export default withRouter(inject("store")(observer(Index)))